<template>
	<div>
		<h4 class="mb-4 font-weight-bold text-center">Split Export Category</h4>
		<GroupedOptions
			v-model="innerValue"
			:options="categoryOptions"
			button-classes="badge badge-pill mx-2 mb-3 text-capitalize"
			class="category-options mx-auto d-flex align-items-center justify-content-center flex-wrap"
		/>
	</div>
</template>

<script>
import GroupedOptions from "@components/GroupedOptions";

export default {
	props: {
		value: String,
		exclude: Array,
	},
	components: {
		GroupedOptions,
	},
	computed: {
		innerValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
		categoryOptions() {
			return [
				{ value: undefined, label: "Combined" },
				{ value: "tpa", label: "TPA" },
				{ value: "umr", label: "UMR" },
				{ value: "coverholder", label: "Coverholder" },
			].map((item) => {
				item.disabled = this.exclude.includes(item.value);

				return item;
			});
		},
	},
	watch: {
		exclude: {
			immediate: true,
			handler(newVal) {
				if (newVal.includes(this.value)) this.$emit("input", undefined);
			},
		},
	},
};
</script>

<style>
.category-options {
	max-width: 400px;
}
</style>
